/** Branchen für Filterung und Auswertung; gespeichert als stabiler Schlüssel, übersetzt in der UI. */
export const CUSTOMER_INDUSTRIES = [
    'RETAIL',
    'WHOLESALE',
    'MANUFACTURING',
    'GASTRONOMY',
    'LOGISTICS',
    'HEALTHCARE',
    'PUBLIC_SECTOR',
    'CONSTRUCTION',
    'AGRICULTURE',
    'SERVICES',
    'OTHER',
];
export const CUSTOMER_INDUSTRY_CODE_MAX_LENGTH = 50;
export const CUSTOMER_TAG_MAX_LENGTH = 40;
export const CUSTOMER_TAGS_MAX_COUNT = 20;
/** Zulässige Sortierspalten der Kundenliste — begrenzt, weil sie direkt in die Query fließen. */
export const CUSTOMER_SORT_FIELDS = [
    'customerNumber',
    'searchTerm',
    'city',
    'status',
    'industry',
    'industryCode',
    'createdAt',
    'updatedAt',
];
export const CUSTOMER_EXPORT_FORMATS = ['csv', 'xlsx'];
/** Obergrenze für Exporte; verhindert unbegrenzte Ergebnismengen in einem Request. */
export const EXPORT_ROW_LIMIT = 10_000;
//# sourceMappingURL=customers.js.map